"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ESCAPES = {
  '"': '\\"',
  '\\': '\\\\',
  '\n': '\\A'
};
var ESCAPE_REGEXP = new RegExp("[" + Object.keys(ESCAPES).join('|') + "]", 'g');
/**
 * Escape a string for use in double quotes.
 */

function escape(value) {
  return value.replace(ESCAPE_REGEXP, function (x) {
    return ESCAPES[x];
  });
}

exports.escape = escape;
/**
 * Quote a string for use in CSS.
 */

function quote(value) {
  return "\"" + escape(value) + "\"";
}

exports.quote = quote;
/**
 * Wrap a string in a CSS `url()` function.
 */

function url(value) {
  return "url(" + quote(value) + ")";
}

exports.url = url;
/**
 * Turn a list of styles into an object.
 */

function objectify() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  var obj = Object.create(null);

  for (var i = 0; i < args.length; i += 2) {
    var key = args[i];
    var value = args[i + 1];

    if (Array.isArray(key)) {
      for (var j = 0; j < key.length; j++) {
        obj[String(key[j])] = value;
      }
    } else {
      obj[String(key)] = value;
    }
  }

  return obj;
}

exports.objectify = objectify;
/**
 * Check if an object looks like a style.
 */

function isStyle(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

exports.isStyle = isStyle;
/**
 * Merge a list of styles together.
 */

function merge() {
  var styles = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    styles[_i] = arguments[_i];
  }

  var result = Object.create(null);

  for (var _a = 0, styles_1 = styles; _a < styles_1.length; _a++) {
    var style = styles_1[_a];

    for (var _b = 0, _c = Object.keys(style); _b < _c.length; _b++) {
      var key = _c[_b];
      var value = style[key];

      if (isStyle(value) && isStyle(result[key])) {
        result[key] = merge(result[key], value);
      } else {
        result[key] = value;
      }
    }
  }

  return result;
}

exports.merge = merge;
/**
 * Register a style sheet object with support for functions.
 */

function registerStyleSheet(Style, sheet, options, registeredName) {
  if (options === void 0) {
    options = {};
  }

  var styles = Object.create(null);
  var keyframes = Object.create(null);
  var hashRules = Object.create(null);
  var prefix = registeredName ? registeredName + "_" : '';

  function invoke(style) {
    if (typeof style === 'function') return style(styles, keyframes, hashRules);
    return style;
  }

  function register(obj, key, compute) {
    if (!options.lazy) {
      var value = compute();
      return Object.defineProperty(obj, key, {
        enumerable: true,
        value: value
      });
    }

    return Object.defineProperty(obj, key, {
      enumerable: true,
      configurable: true,
      get: function get() {
        var value = compute();
        Object.defineProperty(obj, key, {
          enumerable: true,
          value: value
        });
        return value;
      }
    });
  }

  if (typeof options.keyframes === 'object') {
    var _loop_1 = function _loop_1(key) {
      var keyframe = options.keyframes[key];
      register(keyframes, key, function () {
        return Style.registerKeyframes(invoke(keyframe), prefix + key);
      });
    };

    for (var _i = 0, _a = Object.keys(options.keyframes); _i < _a.length; _i++) {
      var key = _a[_i];

      _loop_1(key);
    }
  }

  if (typeof options.hashRules === 'object') {
    var _loop_2 = function _loop_2(key) {
      var _a = options.hashRules[key],
          hashKey = _a[0],
          hashRule = _a[1];
      register(hashRules, key, function () {
        return Style.registerHashRule(hashKey, invoke(hashRule), prefix + key);
      });
    };

    for (var _b = 0, _c = Object.keys(options.hashRules); _b < _c.length; _b++) {
      var key = _c[_b];

      _loop_2(key);
    }
  }

  if (typeof sheet === 'object') {
    var _loop_3 = function _loop_3(key) {
      var style = sheet[key];
      register(styles, key, function () {
        return Style.registerStyle(invoke(style), prefix + key);
      });
    };

    for (var _d = 0, _e = Object.keys(sheet); _d < _e.length; _d++) {
      var key = _e[_d];

      _loop_3(key);
    }
  }

  if (Array.isArray(options.rules)) {
    for (var _f = 0, _g = options.rules; _f < _g.length; _f++) {
      var _h = _g[_f],
          key = _h[0],
          value = _h[1];
      Style.registerRule(key, invoke(value));
    }
  }

  if (typeof options.css === 'object') {
    Style.registerCss(invoke(options.css));
  }

  return styles;
}

exports.registerStyleSheet = registerStyleSheet;